import { Injectable } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { config, type IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowRight,
  faArrowUp,
  faCaretDown,
  faCaretRight,
  faCheck,
  faChevronDown,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCircleInfo,
  faCircleQuestion,
  faCompress,
  faCopy,
  faDesktop as faDesktopSolid,
  faDownload,
  faExpand,
  faEye,
  faLevelDown,
  faLocationDot,
  faMagnifyingGlass,
  faMagnifyingGlassPlus,
  faPhone,
  faPlus,
  faSort,
  faSortDown,
  faSortUp,
  faSquareCheck,
  faStar,
  faTrash,
  faTriangleExclamation,
  faTv,
  faXmark,
} from '@fortawesome/pro-solid-svg-icons';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import {
  faHexagonNodes as faHexagonNodesLight,
  faBuildings as faBuildingsLight,
  faMap as faMapLight,
  faCreditCard as faCreditCardLight,
  faEnvelope as faEnvelopeLight,
  faDatabase as faDatabaseLight,
  faDesktop as faDesktopLight,
  faFire as faFireLight,
  faBriefcaseArrowRight as faBriefcaseArrowRightLight,
  faMicrochip as faMicrochipLight,
  faNewspaper as faNewspaperLight,
  faPeopleGroup as faPeopleGroupLight,
  faSlidersSimple as faSlidersSimpleLight,
  faUpload as faUploadLight,
  faUserPlus as faUserPlusLight,
  faUsers as faUsersLight,
  faLightbulbExclamation as faLightbulbExclamationLight
} from '@fortawesome/pro-light-svg-icons';
import { faFloppyDisk, faTrashCan, faWindowRestore } from '@fortawesome/pro-regular-svg-icons';
import { faPeopleGroup as faPeopleGroupSharpLight } from '@fortawesome/sharp-light-svg-icons';
import { faAiCustom } from '@awesome.me/kit-8c254da4b6/icons/kit/custom';
import { MATERIAL_ICON_TO_FONTAWESOME } from '../icons/material-icon-to-fontawesome-icon-map';

@Injectable({
  providedIn: 'root',
})
export class FontAwesomeIconRegistry {
  constructor(private readonly iconLibrary: FaIconLibrary) {}

  init(): void {
    // Prefer deterministic CSS (bundled in styles.scss), avoid runtime style injection.
    config.autoAddCss = false;

    this.iconLibrary.addIcons(
      faArrowRight,
      faArrowUp,
      faCheck,
      faXmark,
      faCaretDown,
      faCaretRight,
      faTriangleExclamation,
      faMagnifyingGlass,
      faMagnifyingGlassPlus,
      faStar,
      faEye,
      faCopy,
      faDownload,
      faPlus,
      faCompress,
      faExpand,
      faDesktopSolid,
      faPhone,
      faCircle,
      faCircleCheck,
      faCircleInfo,
      faCircleQuestion,
      faLocationDot,
      faLightbulbExclamationLight,
      faSquareCheck,
      faSort,
      faSortDown,
      faSortUp,
      faTrash,
      faTv,
      faLevelDown,
      faFloppyDisk,
      faTrashCan,
      faWindowRestore,
      faChevronDown,
      faChevronUp,
      faLinkedinIn,
      faHexagonNodesLight,
      faBuildingsLight,
      faMapLight,
      faEnvelopeLight,
      faCreditCardLight,
      faDatabaseLight,
      faDesktopLight,
      faFireLight,
      faBriefcaseArrowRightLight,
      faMicrochipLight,
      faNewspaperLight,
      faPeopleGroupLight,
      faSlidersSimpleLight,
      faUploadLight,
      faUserPlusLight,
      faUsersLight,
      faPeopleGroupSharpLight,
      faAiCustom,
    );

    // Register all icons from the canonical Material icon -> Font Awesome mapping.
    // After finalization, templates bind IconProp tuples (e.g. `['fal','magnifying-glass']`)
    // which must resolve via the FaIconLibrary.
    this.iconLibrary.addIcons(...this.getMaterialIconMappingIcons());
  }

  private getMaterialIconMappingIcons(): IconDefinition[] {
    const uniqueIcons = new Map<string, IconDefinition>();
    for (const mapping of Object.values(MATERIAL_ICON_TO_FONTAWESOME)) {
      const icon = mapping.previewIcon;
      uniqueIcons.set(`${icon.prefix}:${icon.iconName}`, icon);
    }
    return [...uniqueIcons.values()];
  }
}

